import { render, staticRenderFns } from "./CreateRequestConsumptionMaterial.vue?vue&type=template&id=5d20518d"
import script from "./CreateRequestConsumptionMaterial.vue?vue&type=script&lang=js"
export * from "./CreateRequestConsumptionMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports